import axios from 'axios'

// 创建axios实例
const service = axios.create({
  timeout: 10000 // 请求超时时间
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 可以在这里添加token等
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    return response.data
  },
  error => {
    return Promise.reject(error)
  }
)

// get请求封装
export function get(url, params = {}, options = {}) {
  const config = {
    method: 'get',
    url: url,
    params: params,
    ...options
  }
  
  // 如果指定了baseURL
  if (options.baseURL) {
    config.baseURL = options.baseURL
  }
  
  return service(config).then(res => {
    if (options.showErrToast && res.code !== 0) {
      // 使用Vant Toast显示错误
      if (typeof window !== 'undefined' && window.Vue) {
        window.Vue.prototype.$toast(res.msg || '请求失败')
      }
    }
    return res
  }).catch(err => {
    if (options.showErrToast) {
      if (typeof window !== 'undefined' && window.Vue) {
        window.Vue.prototype.$toast(err.message || '网络错误')
      }
    }
    return Promise.reject(err)
  })
}

// post请求封装
export function post(url, data = {}, options = {}) {
  const config = {
    method: 'post',
    url: url,
    data: data,
    ...options
  }
  
  if (options.baseURL) {
    config.baseURL = options.baseURL
  }
  
  return service(config).then(res => {
    if (options.showErrToast && res.code !== 0) {
      if (typeof window !== 'undefined' && window.Vue) {
        window.Vue.prototype.$toast(res.msg || '请求失败')
      }
    }
    return res
  }).catch(err => {
    if (options.showErrToast) {
      if (typeof window !== 'undefined' && window.Vue) {
        window.Vue.prototype.$toast(err.message || '网络错误')
      }
    }
    return Promise.reject(err)
  })
}

export default service




